<div class="document-viewer-container">
  <!-- Header with Back and Download buttons -->
  <div class="viewer-header d-flex justify-content-between align-items-center p-3">
    <button mat-stroked-button class="back-btn" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ 'common.back' | translate }}
    </button>

    <button mat-raised-button color="primary" class="download-btn" (click)="onDownload()" *ngIf="document">
      <mat-icon>download</mat-icon>
      {{ 'common.download' | translate }}
    </button>
  </div>

  <!-- Document Content Area -->
  <div class="viewer-content">
    <div *ngIf="loading" class="loading-container d-flex justify-content-center align-items-center">
      <mat-icon class="spin">refresh</mat-icon>
      <span class="ms-2">{{ 'common.loading' | translate }}</span>
    </div>

    <div *ngIf="error" class="error-container text-center py-5">
      <mat-icon class="error-icon">error</mat-icon>
      <h5 class="mt-3">{{ 'documentViewer.error.title' | translate }}</h5>
      <p>{{ 'documentViewer.error.message' | translate }}</p>
    </div>

    <div *ngIf="!loading && !error" class="document-content">
      <div class="document-embed">
        <!-- Iframe viewer for supported document types -->
        <div *ngIf="showIframe && documentUrl && !iframeError" class="document-frame iframe-container">
          <iframe
            [src]="documentUrl"
            class="document-iframe"
            frameborder="0"
            [title]="document.name"
            allow="autoplay"
            (load)="onIframeLoad()"
            (error)="onIframeError()"
          ></iframe>
        </div>

        <!-- Fallback: Preview not available or iframe failed -->
        <div *ngIf="(!showIframe || iframeError) && !isSupported" class="document-frame thumbnail-container">
          <div class="fallback-content">
            <h3 class="document-title">{{ documentPreview?.name || document.name }}</h3>
            <p class="message-text">
              {{ 'documentViewer.documentExtension' | translate }}
            </p>
            <button
              mat-raised-button
              color="primary"
              class="sharepoint-btn"
              (click)="openFullDocument()"
              *ngIf="documentPreview?.webUrl"
            >
              {{ 'documentViewer.openInSharepoint' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
